export enum PRODUCTS_FILTER_ACTIONS {
  TOGGLE_NAVIGATION = "TOGGLE_NAVIGATION",
  SET_ACTIVE_DROPDOWN_FILTER = "SET_ACTIVE_DROPDOWN_FILTER",
  TOGGLE_MOBILE_DRAWER_MENU = "TOGGLE_MOBILE_DRAWER_MENU",
  SET_SORT_BY = "SET_SORT_BY",
  SET_FILTER = "SET_FILTER",
  SET_FILTER_VALUES = "SET_FILTER_VALUES",
  SET_SELECTED_NAVIGATION = "SET_SELECTED_NAVIGATION",
  RESET_FILTER = "RESET_FILTER",
}
